module.exports = __webpack_public_path__ + "static/media/ico-floating-create-active.3ec3ecc6.svg";